/**
 * tabRail: the one class string every underline tab rail in the app
 * shares. Eight rails use it: the client record, Team, Admin review,
 * the Clients page view tabs, My
 * suggestions, the Suggestions queue, the Notifications inbox and
 * Lookup admin.
 *
 * `tablist` carries the rule and belongs on the `role="tablist"`
 * element itself, not an ancestor: the tab's `-mb-px` needs to overlap
 * the rule directly, and an `overflow-x-auto` scroller between the two
 * forces `overflow-y: auto`, which clips the underline's bottom pixel.
 *
 * `tab` is the shared base every tab button carries regardless of
 * state. `inactive` and `active` are the two state classes; `active`
 * sets the ink and weight and the selected tab's soft filled ground
 * (LP-19, Amanda: "some kind of filled something, but don't do an
 * oval"): a low-contrast forest tint with the house tight radius on its
 * top corners only, sitting on the underline, never a pill. A fill
 * changes no box, so the rail keeps its height. `activeSpice` is the
 * same with a pepper ground, for the client record's SPICE tab, which
 * keeps its accent role. Each rail supplies its own active border
 * colour alongside it (`border-forest-700` on every rail today,
 * `border-pepper` on the client record's SPICE tab, `border-warm-400`
 * on the rails that use the gold marker).
 */
const ACTIVE_INK = 'text-sage-800 font-semibold';

/** The selected tab's ground, one per accent (tests pin them). */
export const TAB_RAIL_FILL = { forest: 'bg-sage-100/60', spice: 'bg-pepper-soft' } as const;

export const TAB_RAIL_CLASSES = {
  tablist: 'border-b border-sage-800/[15%]',
  tab:
    'min-h-11 flex items-center gap-2 px-3 py-2 text-sm whitespace-nowrap border-b-[3px] -mb-px rounded-t-tight ' +
    'transition-colors duration-[var(--dur-base)] ease-quiet focus-visible:outline-none ' +
    'focus-visible:ring-2 focus-visible:ring-sage-400',
  inactive: 'border-transparent text-sage-600 font-medium hover:text-sage-800',
  active: `${ACTIVE_INK} ${TAB_RAIL_FILL.forest}`,
  activeSpice: `${ACTIVE_INK} ${TAB_RAIL_FILL.spice}`,
} as const;
